import { Component, OnInit, Input } from '@angular/core';
import { MailInfo } from '../../model/mail-info.model';

@Component({
  selector: 'app-filter-switch-annotation',
  templateUrl: './filter-switch-annotation.component.html',
  styleUrls: ['./filter-switch-annotation.component.scss']
})
export class FilterSwitchAnnotationComponent implements OnInit {
  @Input() show: boolean; 
  @Input() text: string; 

  constructor() {}

  ngOnInit() {}

  
}
